module.exports = __webpack_public_path__ + "static/marijo_split-5a21b6cdba7ef283b7c29ca11a45d164.png";